export const BX_AUTOCOMPLETE = 'aud_all_platform_bx230_autocomplete';
export const BX_DESCKTOP_MAIN_PAGE = 'aud_desktop_bx206_search_string_desktop';

export const EXPERIMENTS: string[] = [BX_AUTOCOMPLETE, BX_DESCKTOP_MAIN_PAGE];
